var _a, _b, _c, _d, _e, _f;
import { Sorts } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import { ESortOrder } from "@domains/utils/sort";
export var MFCalculatorTabsEmum;
(function (MFCalculatorTabsEmum) {
    MFCalculatorTabsEmum["BY_TARGET_AMOUNT"] = "BY_TARGET_AMOUNT";
})(MFCalculatorTabsEmum || (MFCalculatorTabsEmum = {}));
export var MFFundTypeEnum;
(function (MFFundTypeEnum) {
    MFFundTypeEnum[MFFundTypeEnum["EQUITY"] = 13] = "EQUITY";
    MFFundTypeEnum[MFFundTypeEnum["DEBT"] = 7] = "DEBT";
    MFFundTypeEnum[MFFundTypeEnum["HYBRID"] = 10] = "HYBRID";
})(MFFundTypeEnum || (MFFundTypeEnum = {}));
export var MFCalculatorInvestmentTypeEmum;
(function (MFCalculatorInvestmentTypeEmum) {
    MFCalculatorInvestmentTypeEmum["ONE_TIME_LUMPSUM"] = "ONE_TIME_LUMPSUM";
    MFCalculatorInvestmentTypeEmum["EVERY_MONTH_SIP"] = "EVERY_MONTH_SIP";
})(MFCalculatorInvestmentTypeEmum || (MFCalculatorInvestmentTypeEmum = {}));
export var MFCalculatorTabs = [
    {
        title: "By Target amount",
        eventKey: MFCalculatorTabsEmum.BY_TARGET_AMOUNT,
    },
];
export var MFCalculatorInvestment = [
    {
        display: "Lumpsum (One Time)",
        value: MFCalculatorInvestmentTypeEmum.ONE_TIME_LUMPSUM,
    },
    {
        display: "SIP (Every Month)",
        value: MFCalculatorInvestmentTypeEmum.EVERY_MONTH_SIP,
    },
];
export var MFFundType = [
    (_a = {
            value: "Equity",
            display: "Equity",
            defaultValue: MFFundTypeEnum.EQUITY,
            max: 24,
            min: 8,
            jumpOff: 2
        },
        _a[MFCalculatorTabsEmum.BY_TARGET_AMOUNT] = (_b = {},
            _b[MFCalculatorInvestmentTypeEmum.ONE_TIME_LUMPSUM] = 100000,
            _b[MFCalculatorInvestmentTypeEmum.EVERY_MONTH_SIP] = 200000,
            _b),
        _a),
    (_c = {
            value: "Debt",
            display: "Debt",
            defaultValue: MFFundTypeEnum.DEBT,
            max: 11,
            min: 3,
            jumpOff: 1
        },
        _c[MFCalculatorTabsEmum.BY_TARGET_AMOUNT] = (_d = {},
            _d[MFCalculatorInvestmentTypeEmum.ONE_TIME_LUMPSUM] = 100000,
            _d[MFCalculatorInvestmentTypeEmum.EVERY_MONTH_SIP] = 200000,
            _d),
        _c),
    (_e = {
            value: "Hybrid",
            display: "Hybrid",
            defaultValue: MFFundTypeEnum.HYBRID,
            max: 14,
            min: 6,
            jumpOff: 1
        },
        _e[MFCalculatorTabsEmum.BY_TARGET_AMOUNT] = (_f = {},
            _f[MFCalculatorInvestmentTypeEmum.ONE_TIME_LUMPSUM] = 100000,
            _f[MFCalculatorInvestmentTypeEmum.EVERY_MONTH_SIP] = 200000,
            _f),
        _e),
];
export var stepupWithTotalMaxPercent = 5;
export var calculatorTimePeriod = {
    1: "1M",
    6: "6M",
    12: "1Y",
    24: "",
    36: "3Y",
    48: "",
    60: "5Y",
};
export var calculatorBlurEffectEnum;
(function (calculatorBlurEffectEnum) {
    calculatorBlurEffectEnum["CALCULATOR"] = "calculator";
    calculatorBlurEffectEnum["RESULT"] = "result";
})(calculatorBlurEffectEnum || (calculatorBlurEffectEnum = {}));
export var sortIndexConstituents = [
    new Sorts([
        {
            title: "Alphabetical",
            key: "stocks",
            order: ESortOrder.UNCHANGED,
            orderText: {
                desc: "Highest to Lowest",
                asc: "Lowest to Highest",
            },
            type: "string",
        },
        {
            title: "Investment Value",
            key: "investmentValue",
            order: ESortOrder.UNCHANGED,
            orderText: { desc: "Highest to Lowest", asc: "Lowest to Highest" },
        },
        {
            title: "% of AUM",
            key: "percOfAum",
            order: ESortOrder.UNCHANGED,
            orderText: { desc: "Highest to Lowest", asc: "Lowest to Highest" },
        },
        {
            title: "Monthly chg in shares %",
            key: "percMonthChangeInShares",
            order: ESortOrder.UNCHANGED,
            orderText: { desc: "Highest to Lowest", asc: "Lowest to Highest" },
        },
    ]),
];
export var MutualFundQuoteNavigationId;
(function (MutualFundQuoteNavigationId) {
    MutualFundQuoteNavigationId["Mutualfunds_Overview"] = "mutualfund-overview";
    MutualFundQuoteNavigationId["Mutualfunds_Historic_Returns"] = "returns";
    MutualFundQuoteNavigationId["Mutualfunds_5Year_Consistency_Returns"] = "5year-consistency-returns";
    MutualFundQuoteNavigationId["Mutualfunds_Scheme_Information"] = "scheme-information";
    MutualFundQuoteNavigationId["Mutualfunds_Investment_And_Charges"] = "fund-details";
    MutualFundQuoteNavigationId["Mutualfunds_Historic_Calculator"] = "historic-calculator";
    MutualFundQuoteNavigationId["Mutualfunds_Risko_Meter"] = "risk-analysis";
    MutualFundQuoteNavigationId["Mutualfunds_Risk_Measures"] = "risk-measures";
    MutualFundQuoteNavigationId["Mutualfunds_Portfolio_Holding"] = "portfolio-holding";
    MutualFundQuoteNavigationId["Mutualfunds_Portfolio"] = "portfolio";
    MutualFundQuoteNavigationId["Peer_Comparison"] = "peer-comparison";
    MutualFundQuoteNavigationId["Mutualfunds_Fund_House"] = "fund-house";
    MutualFundQuoteNavigationId["Mutualfunds_Understanding_Sections"] = "understanding";
})(MutualFundQuoteNavigationId || (MutualFundQuoteNavigationId = {}));
export var MutualFundsQuoteNavigation = [
    { title: "Overview", id: MutualFundQuoteNavigationId.Mutualfunds_Overview },
    {
        title: "Returns",
        id: MutualFundQuoteNavigationId.Mutualfunds_Historic_Returns,
    },
    // {
    //   title: "5 Y. Consistency",
    //   id: MutualFundQuoteNavigationId.Mutualfunds_5Year_Consistency_Returns,
    // },
    {
        title: "Sch. Info.",
        id: MutualFundQuoteNavigationId.Mutualfunds_Scheme_Information,
    },
    {
        title: "Inv. Charges",
        id: MutualFundQuoteNavigationId.Mutualfunds_Investment_And_Charges,
    },
    // {
    //   title: "Hist. Calcultor",
    //   id: MutualFundQuoteNavigationId.Mutualfunds_Historic_Calculator,
    // },
    {
        title: "Risk Analysis",
        id: MutualFundQuoteNavigationId.Mutualfunds_Risko_Meter,
    },
    // {
    //   title: "Risk Measures",
    //   id: MutualFundQuoteNavigationId.Mutualfunds_Risk_Measures,
    // },
    {
        title: "Portfolio Holding",
        id: MutualFundQuoteNavigationId.Mutualfunds_Portfolio_Holding,
    },
    {
        title: "Peer Comparison",
        id: MutualFundQuoteNavigationId.Peer_Comparison,
    },
    {
        title: "Fund House",
        id: MutualFundQuoteNavigationId.Mutualfunds_Fund_House,
    },
    /* {
      title: "Understanding Section",
      id: MutualFundQuoteNavigationId.Mutualfunds_Understanding_Sections,
    }, */
];
export var NCDExchangeQuoteNavigationId;
(function (NCDExchangeQuoteNavigationId) {
    NCDExchangeQuoteNavigationId["NCDExchange_ExploreOTC"] = "ExploreOTC";
    NCDExchangeQuoteNavigationId["NCDExchange_PriceDetails"] = "Price-details";
    NCDExchangeQuoteNavigationId["NCDExchange_SchemeDetail"] = "Scheme Detail";
    NCDExchangeQuoteNavigationId["NCDExchange_Cash_Flow_Analysis"] = "Cash_Flow_Analysis";
    NCDExchangeQuoteNavigationId["NCDExchange_Ratings"] = "Ratings";
    NCDExchangeQuoteNavigationId["NCDExchange_AboutAMC"] = "AboutAMC";
    NCDExchangeQuoteNavigationId["NCDExchange_CompanyFinacial"] = "CompanyFinacial";
    NCDExchangeQuoteNavigationId["NCDExchange_NCD_Same_Issuer"] = "NCD_Same_Issuer";
    NCDExchangeQuoteNavigationId["NCDExchange_NCD_Other_Issuer"] = "NCD_Other_Issuer";
    NCDExchangeQuoteNavigationId["NCDExchange_Holding"] = "Your-Holdings";
})(NCDExchangeQuoteNavigationId || (NCDExchangeQuoteNavigationId = {}));
export var NCDExchangeQuoteNavigation = [
    // {
    //   title: "Explore NCDs",
    //   id: NCDExchangeQuoteNavigationId.NCDExchange_ExploreOTC,
    // },
    {
        title: "Price Details",
        id: NCDExchangeQuoteNavigationId.NCDExchange_PriceDetails,
    },
    {
        title: "Scheme Detail ",
        id: NCDExchangeQuoteNavigationId.NCDExchange_SchemeDetail,
    },
    {
        title: "Ratings",
        id: NCDExchangeQuoteNavigationId.NCDExchange_Ratings,
    },
    // {
    //   title: "Your Holdings in this NCD",
    //   id: NCDExchangeQuoteNavigationId.NCDExchange_Holding,
    // },
    {
        title: "Cash flow",
        id: NCDExchangeQuoteNavigationId.NCDExchange_Cash_Flow_Analysis,
    },
    {
        title: "About NCD",
        id: NCDExchangeQuoteNavigationId.NCDExchange_AboutAMC,
    },
    {
        title: "Financial",
        id: NCDExchangeQuoteNavigationId.NCDExchange_CompanyFinacial,
    },
    {
        title: "Other NCD from same Issuer",
        id: NCDExchangeQuoteNavigationId.NCDExchange_NCD_Other_Issuer,
    },
    {
        title: "Similar NCD from Other Issuer",
        id: NCDExchangeQuoteNavigationId.NCDExchange_NCD_Same_Issuer,
    },
];
export var NCDIPONavigationId;
(function (NCDIPONavigationId) {
    NCDIPONavigationId["NCDIPO_ExploreOTC"] = "overview";
    NCDIPONavigationId["NCDIPO_Available_Series"] = "Available-Series";
    NCDIPONavigationId["NCDIPO_SchemeDetail"] = "Scheme Detail";
    NCDIPONavigationId["NCDIPO_Cash_Flow_Analysis"] = "Cash_Flow_Analysis";
    NCDIPONavigationId["NCDIPO_Ratings"] = "Ratings";
    NCDIPONavigationId["NCDIPO_AboutAMC"] = "AboutAMC";
    NCDIPONavigationId["NCDIPO_CompanyFinacial"] = "CompanyFinacial";
    NCDIPONavigationId["NCDIPO_NCD_Other_Issuer"] = "NCD_Other_Issuer";
    NCDIPONavigationId["NCDIPO_Holding"] = "Your-Holdings";
    NCDIPONavigationId["NCDIPO_CategoryWiseBreakup"] = "CategoryWiseBreakup";
})(NCDIPONavigationId || (NCDIPONavigationId = {}));
export var NCDIPOQuoteNavigation = [
    {
        title: "Explore NCD IPO",
        id: NCDIPONavigationId.NCDIPO_ExploreOTC,
    },
    {
        title: "Available Series",
        id: NCDIPONavigationId.NCDIPO_Available_Series,
    },
    {
        title: "Scheme Detail",
        id: NCDIPONavigationId.NCDIPO_SchemeDetail,
    },
    // {
    //   title: "Ratings",
    //   id: NCDIPONavigationId.NCDIPO_Ratings,
    // },
    {
        title: "Cash flow",
        id: NCDIPONavigationId.NCDIPO_Cash_Flow_Analysis,
    },
    // {
    //   title: "CategoryWise Breakup",
    //   id: NCDIPONavigationId.NCDIPO_CategoryWiseBreakup,
    // },
    {
        title: "About Company",
        id: NCDIPONavigationId.NCDIPO_AboutAMC,
    },
    {
        title: "Financial",
        id: NCDIPONavigationId.NCDIPO_CompanyFinacial,
    },
    {
        title: "Other NCD from same Issuer",
        id: NCDIPONavigationId.NCDIPO_NCD_Other_Issuer,
    },
];
export var schemeType = ["Regular", "Direct"];
export var returnType = ["Growth", "IDCW"];
export var IndexReturnType = ["Growth"];
